// extracted by mini-css-extract-plugin
export default {"video":"WlaewVGc0ItupKW8a1yg","img":"cgCheLzDRkaW5OCkn8wo","hidden":"lh92ZWQHllE56OcDCygc"};